module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container text-center g-pt-70"
  }, [_c('h2', {
    staticClass: "h1 mb-3"
  }, [_vm._v("Looking for additional support?")]), _vm._v(" "), _c('p', {
    staticClass: "g-font-size-20"
  }, [_vm._v("Check out these other programs from OneSight EssilorLuxottica Foundation to support your charitable work.")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 offset-md-2"
  }, [_c('div', {
    staticClass: "row g-mb-30 justify-content-center"
  }, [_c('div', {
    staticClass: "col-sm-6 col-lg-6 g-mb-30 home-page-invite"
  }, [_c('a', {
    staticClass: "no-underline g-color-main g-color-primary--hover",
    attrs: {
      "href": "https://www.evfusa.org/get-involved/in-office-donation-campaigns/",
      "target": "_blank"
    },
    on: {
      "mouseover": function($event) {
        return _vm.HoverDonation('enter')
      },
      "mouseleave": function($event) {
        return _vm.HoverDonation('leave')
      }
    }
  }, [_c('img', {
    staticClass: "img-fluid home-page-icon rounded-circle mx-auto g-mb-30 g-mt-30",
    attrs: {
      "src": _vm.donationIcon,
      "alt": "Image Description"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_vm._v("In-Office Donation Campaign")])]), _vm._v(" "), _vm._m(0)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-px-30--lg"
  }, [_c('p', {
    staticClass: "g-color-text-light-v1 mb-0 g-font-size-20"
  }, [_vm._v("Inspire patients and staff to adopt the cause of vision and raise funds.")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6d7e0a5c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d7e0a5c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/portal/homeData/HomeSupport.vue
// module id = 521
// module chunks = 3